/* Retail-posture PDP behaviour.

   Three jobs:
     1. Bundle ladder - click a tier, the hidden variant id follows it, and the
        gallery swaps to that pack's photo if one is wired.
     2. Subscription checkbox - ticking it attaches the selling plan to the
        SAME variant and reveals the recurring terms directly above the button.
        Shopify subscriptions are not a separate variant: the cart add must
        post both id and selling_plan, or the customer gets a silent one-time
        order that looks like a subscription to nobody but them.
     3. Thumbnail gallery.

   avatar-landing.js already wires the lightbox and the countdown; this file
   only handles what is new to this layout. */
(function () {

  function wirePdpForm(form) {
    if (form.dataset.pdpWired) return;
    form.dataset.pdpWired = '1';

    var vid   = form.querySelector('.offer-vid');
    var plan  = form.querySelector('.offer-plan');
    var terms = form.querySelector('.subterms');
    var box   = form.querySelector('.psub-box');
    var tiers = form.querySelectorAll('.ptier');
    var col   = form.closest('.pdpgrid');
    var hero  = col ? col.querySelector('.pdpmain img') : null;
    var thumbs = col ? col.querySelectorAll('.thumb') : [];

    function selected() {
      for (var i = 0; i < tiers.length; i++) {
        if (tiers[i].classList.contains('on')) return tiers[i];
      }
      return tiers[0] || null;
    }

    function syncHero(tier) {
      var src = tier && tier.getAttribute('data-img');
      if (!hero || !src) return;
      hero.src = src;
      // Keep the thumbnail strip honest about what is on screen.
      Array.prototype.forEach.call(thumbs, function (t) {
        t.classList.toggle('on', t.getAttribute('data-full') === src);
      });
    }

    function apply() {
      var tier = selected();
      if (!tier) return;
      if (vid) vid.value = tier.getAttribute('data-vid') || '';
      var on = box && box.checked;
      if (plan) plan.value = on ? (box.getAttribute('data-plan') || '') : '';
      if (terms) terms.hidden = !on;
    }

    Array.prototype.forEach.call(tiers, function (tier) {
      tier.addEventListener('click', function () {
        Array.prototype.forEach.call(tiers, function (t) { t.classList.remove('on'); });
        tier.classList.add('on');
        apply();
        syncHero(tier);
      });
    });

    if (box) box.addEventListener('change', apply);

    // Server-rendered state is the source of truth on load: whichever tier
    // carries .on already has the right pack shot behind it.
    apply();
  }

  function wireThumbs(root) {
    if (root.dataset.thumbWired) return;
    root.dataset.thumbWired = '1';

    var heroId = root.getAttribute('data-pdp-thumbs');
    var hero = heroId ? document.getElementById(heroId) : null;
    var track = root.querySelector('.thumbtrack');
    var thumbs = root.querySelectorAll('.thumb');

    Array.prototype.forEach.call(thumbs, function (t) {
      t.addEventListener('click', function () {
        if (hero) hero.src = t.getAttribute('data-full');
        Array.prototype.forEach.call(thumbs, function (o) { o.classList.remove('on'); });
        t.classList.add('on');
      });
    });

    // Mice do not swipe. Without arrows a scrolling strip reads as broken on
    // desktop, which is exactly how the first build of this looked.
    function nudge(dir) {
      if (track) track.scrollLeft += dir * Math.max(160, track.clientWidth * 0.7);
    }
    var prev = root.querySelector('.thumbprev');
    var next = root.querySelector('.thumbnext');
    if (prev) prev.addEventListener('click', function () { nudge(-1); });
    if (next) next.addEventListener('click', function () { nudge(1); });

    function paint() {
      if (!track || !prev || !next) return;
      var overflow = track.scrollWidth > track.clientWidth + 2;
      prev.hidden = !overflow || track.scrollLeft <= 2;
      next.hidden = !overflow || track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    if (track) track.addEventListener('scroll', paint);
    window.addEventListener('resize', paint);
    paint();
  }

  /* Clips are tap-to-play: three of them starting at once is disorienting and
     it is not what the visitor asked for. Nothing here starts playback. The
     observer only pauses a clip the visitor started once it leaves the screen,
     so audio never comes from something they cannot see. */
  function wireClips() {
    var vids = document.querySelectorAll('.vcell video, .fmedia video');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting && !e.target.paused) e.target.pause();
      });
    }, { threshold: 0.2 });
    Array.prototype.forEach.call(vids, function (v) { io.observe(v); });

    /* One at a time: starting a clip stops whichever one was already running. */
    Array.prototype.forEach.call(vids, function (v) {
      v.addEventListener('play', function () {
        Array.prototype.forEach.call(vids, function (o) { if (o !== v) o.pause(); });
      });
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('form.pdpform'), wirePdpForm);
    Array.prototype.forEach.call(document.querySelectorAll('[data-pdp-thumbs]'), wireThumbs);
    wireClips();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* Store header drawer. Kept in this file because every layout that renders the
   header already loads it. Focus is moved into the panel and the page behind is
   locked, so the drawer is not a div that merely looks like a menu. */
(function () {
  function wireDrawer(head) {
    if (head.dataset.drawWired) return;
    head.dataset.drawWired = '1';

    var open  = head.querySelector('.sdraw-open');
    var draw  = head.querySelector('.sdraw');
    if (!open || !draw) return;
    var close = draw.querySelector('.sdraw-close');
    var panel = draw.querySelector('.sdraw-panel');

    function show() {
      draw.hidden = false;
      open.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (close) close.focus();
    }
    function hide() {
      draw.hidden = true;
      open.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      open.focus();
    }

    open.addEventListener('click', show);
    if (close) close.addEventListener('click', hide);
    // Clicking the dimmed area closes; clicking inside the panel must not.
    draw.addEventListener('click', function (e) {
      if (!panel || !panel.contains(e.target)) hide();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !draw.hidden) hide();
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.shead'), wireDrawer);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
